<template>
    <el-dialog custom-class="dialogForm" class="measDialog" :visible.sync="visible" :before-close="handleClose" :close-on-click-modal="false" width="80%" title="新增订单">
        <el-scrollbar class="dialogContentScroll">
            <el-form :model="form" ref="form" :rules="rules">
                <el-form-item prop="studentcode" label="学员昵称">
                    <div class="flex ai-c">
                        <SelectPage v-if="visible" @changePageGetList="changeStudentPage" @getSelectValue="getStudentValue" :list="studentList" :label="'nickname'" :value="'studentcode'" :paginationOption="studentPage" :isMultiple="false" :listLoading="studentLoading"></SelectPage>
                        <el-button type="primary" class="ml-15" @click="openAddStudent">新增学员</el-button>
                        <AddStudent ref="AddStudent" @saveSuccess="saveSuccess"></AddStudent>
                    </div>
                </el-form-item>
                <el-form-item prop="classcode" label="班级名称">
                    <SelectPage v-if="visible" @changePageGetList="changeClassPage" @getSelectValue="getClassValue" :list="classList" :label="'name'" :value="'code'" :paginationOption="classPage" :isMultiple="false" :listLoading="classLoading"></SelectPage>
                </el-form-item>
                <el-form-item prop="uprice" label="订单金额">
                    <el-input v-model="form.uprice" placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item prop="nowprice" label="支付金额">
                    <el-input v-model="form.nowprice" placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item prop="paytype" label="支付方式">
                    <el-select v-model="form.paytype" clearable>
                        <el-option v-for="item in paytypeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="datetime" label="下单时间">
                    <el-date-picker v-model="form.datetime" type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
                <el-form-item prop="paytime" label="支付时间">
                    <el-date-picker v-model="form.paytime" type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
            </el-form>
        </el-scrollbar>
        <div slot="footer" style="text-align:right">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" :loading="isLoading" @click="saveOrderInfo">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import SelectPage from '@/components/measComponents/selectPage/selectPage.vue'
import {
  getStudentListBySelect,
  getClassListBySelect,
  saveOrderInfo
} from '@/api/measApi/transactionManage.js'
import AddStudent from '@/views/meas/studentManage/studentManage/components/addStudent.vue'
import { dateFormat } from '@/assets/measAssets/js/tools.js'
export default {
  data() {
    return {
      visible: false,
      form: {
        classcode: '', // 班级code
        code: '', // 目标code
        datetime: dateFormat(new Date()),
        isaddclass: true, // 学员入班级
        memo: '', // 留言
        nowprice: '', // 支付金额（元）
        paytime: dateFormat(new Date()),
        paytype: '', // 付款方式：1 支付宝支付 2 微信支付 3 银行支付
        studentcode: '', // 学员code
        uprice: '' // 订单金额（元）
      },
      rules: {
        paytype: [
          { required: true, message: '请选择支付方式', trigger: 'change' }
        ],
        studentcode: [
          { required: true, message: '请选择学员', trigger: 'change' }
        ],
        classcode: [
          { required: true, message: '请选择班级', trigger: 'change' }
        ],
        uprice: [
          { required: true, message: '请输入订单金额', trigger: 'blur' }
        ],
        nowprice: [
          { required: true, message: '请输入支付金额', trigger: 'blur' }
        ]
      },
      paytypeList: [
        {
          value: 1,
          label: '支付宝支付'
        },
        {
          value: 2,
          label: '微信支付'
        },
        {
          value: 3,
          label: '银行支付'
        }
      ],
      studentList: [],
      studentPage: {
        pagesize: 5,
        page: 1,
        total: 0
      },
      studentLoading: false,
      classList: [],
      classPage: {
        pagesize: 5,
        page: 1,
        total: 0
      },
      classLoading: false,
      isLoading: false,
      orgForm: {}
    }
  },
  components: {
    SelectPage,
    AddStudent
  },
  methods: {
    handleOpen() {
      this.visible = true
      this.orgForm = JSON.parse(JSON.stringify(this.form))
      this.getStudentListBySelect()
      this.getClassListBySelect()
    },
    // 获取学员下拉
    getStudentListBySelect() {
      const parmas = {
        condition: {
          keyword: '',
          status: ''
        },
        orderbyname: '',
        orderbyorder: '',
        page: this.studentPage.page,
        pagesize: this.studentPage.pagesize
      }
      this.studentLoading = true
      getStudentListBySelect(parmas).then(res => {
        if (res.code === '000') {
          this.studentList = res.data
          this.studentPage.total = res.pageinfo.rowcount
          this.studentLoading = false
        }
      })
    },
    // 学员分页
    changeStudentPage(page) {
      this.studentPage.page = page
      this.getStudentListBySelect()
    },
    // 获取选中的学员
    getStudentValue(args) {
      this.form.studentcode = args[0].studentcode
    },
    // 获取班级下拉
    getClassListBySelect() {
      const parmas = {
        condition: {
          keyword: '',
          status: ''
        },
        orderbyname: '',
        orderbyorder: '',
        page: this.classPage.page,
        pagesize: this.classPage.pagesize
      }
      this.classLoading = true
      getClassListBySelect(parmas).then(res => {
        if (res.code === '000') {
          this.classList = res.data
          this.classPage.total = res.pageinfo.rowcount
          this.classLoading = false
        }
      })
    },
    // 班级分页
    changeClassPage(page) {
      this.classPage.page = page
      this.getClassListBySelect()
    },
    // 获取班级
    getClassValue(args) {
      this.form.classcode = args[0].code
      this.form.uprice = args[0].uprice
      this.form.nowprice = args[0].uprice
    },
    openAddStudent() {
      this.$refs.AddStudent.handleOpen('')
    },
    saveSuccess() {
      this.studentPage.page = 1
      this.getStudentListBySelect()
    },
    // 保存
    saveOrderInfo() {
      this.$refs.form.validate(validate => {
        if (validate) {
          if (Number(this.form.nowprice) > Number(this.form.uprice)) {
            this.$message.warning('支付金额不能大于订单金额')
            return
          }
          this.isLoading = true
          saveOrderInfo(this.form).then(res => {
            if (res.code === '000') {
              this.$message.success(res.msg)
              this.$emit('saveSuccess')
              this.isLoading = false
              this.handleClose()
            }
          })
        }
      })
    },
    handleClose() {
      if (this.isLoading) {
        this.$message.warning('提交数据中，请稍等')
        return
      }
      this.visible = false
      this.form = this.orgForm
      this.$refs.form.clearValidate()
    }
  }
}
</script>

